/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance.ts";

function getPatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceUrl(
  classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams["classModuleId"],
  disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams["disciplineId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/class-modules/${classModuleId}/disciplines/${disciplineId}/included-in-attendance` as const,
  };
  return res;
}

/**
 * @description Inverte a flag IsIncludedInAttendanceCalculation da Disciplina no Módulo. Se a configuração ainda não existir, ela é criada. Retorna o estado atualizado da configuração. **(Requer Authorization para autenticação)**
 * @summary Alternar 'Considerar no cálculo de frequência' (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/included-in-attendance}
 */
export async function patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance(
  classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams["classModuleId"],
  disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams["disciplineId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceUrl(
      classModuleId,
      disciplineId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
